export default "data:text/javascript;base64,aW1wb3J0IFRRdWlja0FjdGlvbnMgZnJvbSAiLi9UUXVpY2tBY3Rpb25zLnZ1ZSI7CgpleHBvcnQgZGVmYXVsdCBUUXVpY2tBY3Rpb25zOwo="